import { ISize } from 'shared/types/Size';

export const getSizeOptionsMap = (sizeOptions: ISize[]) => {
  const sizeOptionsMap = new Map<number, ISize>();
  if (Array.isArray(sizeOptions)) {
    for (const size of sizeOptions) {
      sizeOptionsMap.set(size.value, size);
    }
  }

  return sizeOptionsMap;
};
